'use client';

import { css } from '@linaria/core';

export const root = css`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: min-content min-content min-content 1fr;
  min-height: 100%;
`;
